import * as React from 'react';
import { Modal } from 'rcd-cpp-ui/ui/modal/Modal';
import { Buttons, Cancel, Primary } from 'rcd-cpp-ui/ui/button';
import { useNavigate } from 'react-router-dom';
import { Group } from 'rcd-cpp-ui/ui/form/Group';
import { useAlert } from '../Alert/alert';
import { useLoader } from '../Loader/loader';
import { Workspace } from '../../types/Metadata';
import { Spinner } from 'rcd-cpp-ui/ui/loader';
import { useSelector } from '../../utils/useSelector';

export const CreateWorkspace = () => {
  const getAPI = useSelector(s => s.app?.elFn?.getAPI);
  const [workspaces, setWorkspaces] = React.useState<Workspace[]>(null);
  const [name, setName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [prefix, setPrefix] = React.useState('');
  const [parentRefId, setParentRefId] = React.useState('');
  const [createMyItemsViews, setCreateMyItemsViews] = React.useState(true);
  const [allowOwnCustomData, setAllowOwnCustomData] = React.useState(true);
  const [allowAddNewItems, setAllowAddNewItems] = React.useState(null);
  const navigate = useNavigate();
  const { isLoading, setMessage, Loader, Alert, create } = useAlert(
    useLoader({
      create: async () => {
        const { createWorkspace } = getAPI();
        const r = await createWorkspace({
          value: {
            name,
            prefix,
            parentRefId,
            allowOwnCustomData,
            allowAddNewItems,
            createMyItemsViews,
            description
          }
        });
        let msg = [];
        if (r.createdWorkspace) msg.push(`${name} Created!`);
        if (r.myItemsViewsCreated)
          msg.push(`${r.myItemsViewsCreated} my items views Created!`);
        if (!msg.length) msg.push('Nothing is created....');
        setMessage({ type: 'success', message: msg.join(' ') });
        setName('');
        setPrefix('');
        setDescription('');
        setParentRefId('');
      }
    })
  );
  React.useEffect(() => {
    const { getWorkspaces } = getAPI();
    getWorkspaces().then(ws => {
      setWorkspaces(ws);
    });
  }, []);
  const itemTypes = [
    { value: 'content', label: 'Content' },
    { value: 'globalSubmission', label: 'Global Submission' }
  ];
  return (
    <Modal
      header="Create New Workspace"
      id="createWorkspaceModal"
      height="70%"
      footer={
        <Buttons>
          <Cancel onClick={() => navigate('/')} />
          <Primary
            label="Create"
            disabled={!name || !prefix || isLoading}
            onClick={create}
          />
        </Buttons>
      }
    >
      <Alert />
      <Loader />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px'
        }}
      >
        <Group label="Workspace Name">
          <input
            className="form-control"
            type="text"
            value={name}
            onChange={e => {
              setName(e.target.value);
            }}
          />
        </Group>
        <Group label="Custom Data Type Prefix">
          <input
            className="form-control"
            type="text"
            value={prefix}
            onChange={e => {
              setPrefix(e.target.value.toUpperCase());
            }}
          />
        </Group>
        <Group label="Description">
          <textarea
            className="form-control"
            value={description}
            rows={3}
            onChange={e => {
              setDescription(e.target.value);
            }}
          />
        </Group>
        <div className="cpp-ui cpp-ui-form-group">
          <input
            id="createMyItemsViews"
            type="checkbox"
            checked={createMyItemsViews}
            onChange={e => {
              setCreateMyItemsViews(e.target.checked);
            }}
          />
          <label htmlFor="createMyItemsViews">
            &nbsp; Create My Items views
          </label>
        </div>
        <div className="cpp-ui cpp-ui-form-group">
          <input
            id="allowCustomData"
            type="checkbox"
            checked={allowOwnCustomData}
            onChange={e => {
              setAllowOwnCustomData(e.target.checked);
            }}
          />
          <label htmlFor="allowCustomData">&nbsp; Allow own custom data</label>
        </div>
        <div className="cpp-ui cpp-ui-form-group">
          <input
            id="canAddPlanningItem"
            type="checkbox"
            checked={allowAddNewItems?.length > 0}
            onChange={e => {
              setAllowAddNewItems(
                e.target.checked ? ['content', 'globalSubmission'] : null
              );
            }}
          />
          <label htmlFor="canAddPlanningItem">
            &nbsp; Can add new Planning Item
          </label>
        </div>
        {allowAddNewItems?.length > 0 && allowAddNewItems != null && (
          <Group label="Add New Item Type">
            <div className="cpp-ui cpp-ui-form-group">
              {itemTypes.map(type => (
                <label
                  key={type.value}
                  style={{
                    marginLeft: type.value != itemTypes[0].value ? '1em' : 0
                  }}
                >
                  <input
                    type="checkbox"
                    checked={allowAddNewItems.includes(type.value)}
                    onChange={e => {
                      setAllowAddNewItems(prev => {
                        const next = e.target.checked
                          ? Array.from(new Set([...(prev || []), type.value]))
                          : prev.filter(v => v != type.value);
                        return next.length == 0 ? null : next;
                      });
                    }}
                  />
                  &nbsp; {type.label}
                </label>
              ))}
            </div>
          </Group>
        )}
        <Group label="Parent Workspace (optional)">
          {!workspaces && <Spinner spinnerSize="icon" />}
          {!!workspaces && (
            <select
              className="form-control"
              onChange={e => {
                setParentRefId(e.target.value);
              }}
            >
              <option value="" selected={!parentRefId}>
                --
              </option>
              {workspaces.map(w => {
                return (
                  <option
                    key={w.id}
                    value={w.props.refId}
                    selected={parentRefId == w.props.refId}
                  >
                    {w.props.name}
                  </option>
                );
              })}
            </select>
          )}
        </Group>
      </div>
    </Modal>
  );
};
